import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface LoaderButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
}

export const LoaderButton: React.FC<LoaderButtonProps> = ({
  loading = false,
  loadingText = 'Loading...',
  children,
  disabled,
  ...props
}) => {
  return (
    <Button disabled={disabled || loading} {...props}>
      {loading ? (
        <>
          <CircularProgress size={20} sx={{ mr: 1 }} />
          {loadingText}
        </>
      ) : (
        children
      )}
    </Button>
  );
};
